export const SAVE_POKEMONS = 'SAVE_POKEMONS'
export const SAVE_POKEMON = 'SAVE_POKEMON'
export const ADD_TO_FAVORITE = 'ADD_TO_FAVORITE'
export const REMOVE_FROM_FAVORITE = 'REMOVE_FROM_FAVORITE'
export const GET_FAVORITE_FROM_LOCAL_STORAGE = 'GET_FAVORITE_FROM_LOCAL_STORAGE'
